(function() {
  const STORAGE_KEY = 'pet_name';
  const ENABLED_STORAGE_KEY = 'pet_name_enabled';
  const DEFAULT_ATTRIBUTE_NAME = 'Nombre mascota';
  const PERSONALIZATION_FLAG_KEYS = ['_personalizacion_nombre_mascota', '_personalization_nombre_mascota'];
  const PERSONALIZATION_LINE_KEYS = [
    'Pet name',
    'Nombre mascota',
    '_pet_name_uid',
    '_pet_name_parent_uid',
    '_pet_name_fee',
    '_pet_name_fee_quantity_mode',
    '_for_variant_id'
  ].concat(PERSONALIZATION_FLAG_KEYS);
  const DEBUG = window.Shopify && window.Shopify.designMode;
  let isSyncingPersonalization = false;
  let queuedRemovalContext = null;
  let personalizationSyncTimeout = null;
  let cartUpdateSubscriptionBound = false;

  function debugLog() {
    if (!DEBUG || !window.console || typeof console.log !== 'function') return;
    console.log.apply(console, arguments);
  }

  function createPersonalizationUid() {
    return ['pet-name', Date.now(), Math.random().toString(36).slice(2, 10)].join('-');
  }

  function getBlock() {
    return document.querySelector('[data-pet-name-block]');
  }

  function getInput() {
    return document.querySelector('[data-pet-name-input]');
  }

  function getToggle() {
    return document.querySelector('[data-pet-name-toggle]');
  }

  function getFields() {
    return document.querySelector('[data-pet-name-fields]');
  }

  function getErrorElement() {
    return document.querySelector('[data-pet-name-error]');
  }

  function cleanValue(value) {
    return String(value || '').trim();
  }

  function normalizePropertyValue(value) {
    return String(value == null ? '' : value).trim();
  }

  function getPropertyValue(properties, key) {
    if (!properties || typeof properties !== 'object') return '';
    return normalizePropertyValue(properties[key]);
  }

  function hasTruthyProperty(properties, key) {
    const value = getPropertyValue(properties, key).toLowerCase();
    return value !== '' && value !== 'false' && value !== '0' && value !== 'null' && value !== 'undefined';
  }

  function getPersonalizationPropertyNames(item) {
    const names = new Set(PERSONALIZATION_LINE_KEYS);
    const properties = item && item.properties && typeof item.properties === 'object' ? item.properties : {};

    Object.keys(properties).forEach(function(key) {
      const normalizedKey = normalizePropertyValue(key).toLowerCase();

      if (
        normalizedKey === 'pet name' ||
        normalizedKey === 'nombre mascota' ||
        normalizedKey.indexOf('mascota') !== -1 ||
        normalizedKey.indexOf('pet_name') !== -1
      ) {
        names.add(key);
      }
    });

    return Array.from(names);
  }

  function getPersonalizationNameValue(item) {
    const properties = item && item.properties && typeof item.properties === 'object' ? item.properties : {};
    const keys = Object.keys(properties);

    for (let index = 0; index < keys.length; index += 1) {
      const key = keys[index];
      const normalizedKey = normalizePropertyValue(key).toLowerCase();

      if (normalizedKey === 'pet name' || normalizedKey === 'nombre mascota') {
        return getPropertyValue(properties, key);
      }
    }

    return '';
  }

  function getPersonalizationCartAttributeNames(cart) {
    const names = new Set(['Pet name', 'Nombre mascota']);
    const configuredAttributeName = getAttributeName();

    if (configuredAttributeName) {
      names.add(configuredAttributeName);
    }

    const attributes = cart && cart.attributes && typeof cart.attributes === 'object' ? cart.attributes : {};

    Object.keys(attributes).forEach(function(key) {
      const normalizedKey = normalizePropertyValue(key).toLowerCase();

      if (
        normalizedKey === 'pet name' ||
        normalizedKey === 'nombre mascota' ||
        normalizedKey.indexOf('mascota') !== -1 ||
        normalizedKey.indexOf('pet_name') !== -1
      ) {
        names.add(key);
      }
    });

    return Array.from(names);
  }

  function getAttributeName() {
    const input = getInput();
    const attributeName = input?.dataset.petNameAttribute?.trim();

    return attributeName || DEFAULT_ATTRIBUTE_NAME;
  }

  function boolFromDataset(value, defaultValue) {
    if (value === undefined || value === null || value === '') return defaultValue;
    return String(value) === 'true';
  }

  function isPersonalizationEnabled() {
    const toggle = getToggle();

    if (!toggle) {
      return Boolean(getInput());
    }

    return Boolean(toggle.checked && !toggle.disabled);
  }

  function isNameRequired() {
    const block = getBlock();
    return boolFromDataset(block?.dataset.petNameRequireName, true);
  }

  function isPersonalizationProductAvailable() {
    const block = getBlock();
    return boolFromDataset(block?.dataset.petNameProductAvailable, false);
  }

  function getPersonalizationVariantId() {
    const block = getBlock();
    const variantId = block?.dataset.petNameProductVariantId;

    if (!variantId) return null;

    const parsedVariantId = parseInt(variantId, 10);
    return Number.isNaN(parsedVariantId) ? null : parsedVariantId;
  }

  function getFeeQuantity(mainQuantity) {
    const block = getBlock();
    const mode = block?.dataset.petNameFeeQuantityMode || 'match_quantity';
    const quantity = Math.max(1, parseInt(mainQuantity, 10) || 1);

    return mode === 'once' ? 1 : quantity;
  }

  function getPersonalizationConfig() {
    const block = getBlock();
    const configuredVariantId = getPersonalizationVariantId();
    const quantityMode = block?.dataset.petNameFeeQuantityMode || 'match_quantity';

    return {
      variantId: configuredVariantId,
      quantityMode: quantityMode === 'once' ? 'once' : 'match_quantity'
    };
  }

  function assignCartLineNumbers(cart) {
    if (!cart || !Array.isArray(cart.items)) return cart;

    cart.items.forEach(function(item, index) {
      item.line = index + 1;
    });

    return cart;
  }

  function isPersonalizationFeeItem(item, config) {
    if (!item) return false;

    const variantId = parseInt(item.variant_id, 10);
    const configuredVariantId = config && config.variantId ? parseInt(config.variantId, 10) : null;

    if (configuredVariantId && variantId === configuredVariantId) {
      return true;
    }

    return hasTruthyProperty(item.properties, '_pet_name_fee');
  }

  function isPersonalizedMainItem(item, config) {
    if (!item || isPersonalizationFeeItem(item, config)) return false;

    if (hasTruthyProperty(item.properties, '_pet_name_uid')) return true;
    if (getPersonalizationNameValue(item)) return true;

    return PERSONALIZATION_FLAG_KEYS.some(function(key) {
      return hasTruthyProperty(item.properties, key);
    });
  }

  function cleanPersonalizationProperties(properties) {
    const cleanedProperties = {};
    const source = properties && typeof properties === 'object' ? properties : {};
    const removableKeys = getPersonalizationPropertyNames({ properties: source });

    Object.keys(source).forEach(function(key) {
      if (removableKeys.indexOf(key) !== -1) return;
      cleanedProperties[key] = source[key];
    });

    return cleanedProperties;
  }

  function getLinkedUid(item, propertyName) {
    return getPropertyValue(item && item.properties, propertyName);
  }

  function getFeeQuantityMode(mainItem, feeItem, config) {
    const explicitMode =
      getPropertyValue(mainItem && mainItem.properties, '_pet_name_fee_quantity_mode') ||
      getPropertyValue(feeItem && feeItem.properties, '_pet_name_fee_quantity_mode');

    if (explicitMode === 'once') return 'once';
    if (explicitMode === 'match_quantity') return 'match_quantity';

    return config.quantityMode;
  }

  function buildLegacyCandidateMap(mainItems, feeItems) {
    const feeToMain = new Map();
    const mainToFee = new Map();

    feeItems.forEach(function(feeItem) {
      const parentVariantId = parseInt(getPropertyValue(feeItem.properties, '_for_variant_id'), 10);
      const feePetName = getPersonalizationNameValue(feeItem).toLowerCase();

      const candidates = mainItems.filter(function(mainItem) {
        if (mainToFee.has(mainItem.line)) return false;
        if (parentVariantId && parseInt(mainItem.variant_id, 10) !== parentVariantId) return false;

        const mainPetName = getPersonalizationNameValue(mainItem).toLowerCase();
        if (feePetName && mainPetName && feePetName !== mainPetName) return false;

        return true;
      });

      if (candidates.length === 1) {
        feeToMain.set(feeItem.line, candidates[0].line);
        mainToFee.set(candidates[0].line, feeItem.line);
      }
    });

    return { feeToMain: feeToMain, mainToFee: mainToFee };
  }

  function linkPersonalizationItems(cart, config) {
    const items = Array.isArray(cart && cart.items) ? cart.items : [];
    const mainItems = items.filter(function(item) {
      return isPersonalizedMainItem(item, config);
    });
    const feeItems = items.filter(function(item) {
      return isPersonalizationFeeItem(item, config);
    });
    const feeToMain = new Map();
    const mainToFee = new Map();

    feeItems.forEach(function(feeItem) {
      const parentUid = getLinkedUid(feeItem, '_pet_name_parent_uid');
      if (!parentUid) return;

      const mainItem = mainItems.find(function(candidate) {
        return getLinkedUid(candidate, '_pet_name_uid') === parentUid;
      });

      if (!mainItem) return;

      feeToMain.set(feeItem.line, mainItem.line);
      mainToFee.set(mainItem.line, feeItem.line);
    });

    if (feeItems.length === 1 && mainItems.length === 1 && feeToMain.size === 0) {
      feeToMain.set(feeItems[0].line, mainItems[0].line);
      mainToFee.set(mainItems[0].line, feeItems[0].line);
      return { feeItems: feeItems, mainItems: mainItems, feeToMain: feeToMain, mainToFee: mainToFee };
    }

    const legacyLinks = buildLegacyCandidateMap(
      mainItems.filter(function(item) {
        return !mainToFee.has(item.line);
      }),
      feeItems.filter(function(item) {
        return !feeToMain.has(item.line);
      })
    );

    legacyLinks.feeToMain.forEach(function(mainLine, feeLine) {
      feeToMain.set(feeLine, mainLine);
    });

    legacyLinks.mainToFee.forEach(function(feeLine, mainLine) {
      mainToFee.set(mainLine, feeLine);
    });

    return { feeItems: feeItems, mainItems: mainItems, feeToMain: feeToMain, mainToFee: mainToFee };
  }

  async function fetchCurrentCart() {
    const response = await fetch('/cart.js', {
      headers: {
        'Accept': 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error('No se pudo obtener el carrito actual.');
    }

    return response.json().then(assignCartLineNumbers);
  }

  async function changeCartLine(payload) {
    const response = await fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(payload)
    });

    const result = await response.json();

    if (!response.ok) {
      throw new Error(result.description || result.message || 'No se pudo sincronizar la personalización.');
    }

    return assignCartLineNumbers(result);
  }

  async function addCartItem(item) {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ items: [item] })
    });

    const result = await response.json();

    if (!response.ok) {
      throw new Error(result.description || result.message || 'No se pudo restaurar el producto sin personalizaciÃ³n.');
    }

    return result;
  }

  async function cleanCartLinePersonalization(item) {
    const properties = cleanPersonalizationProperties(item.properties);

    if (Object.keys(properties).length > 0) {
      return changeCartLine({
        id: item.key,
        quantity: item.quantity,
        properties: properties
      });
    }

    await changeCartLine({
      id: item.key,
      quantity: 0
    });

    const replacementItem = {
      id: item.variant_id,
      quantity: item.quantity
    };
    const sellingPlanId = item.selling_plan_allocation && item.selling_plan_allocation.selling_plan
      ? item.selling_plan_allocation.selling_plan.id
      : null;

    if (sellingPlanId) replacementItem.selling_plan = sellingPlanId;

    await addCartItem(replacementItem);
    return fetchCurrentCart();
  }

  async function executePersonalizationAction(action) {
    if (action.type === 'clean') {
      return cleanCartLinePersonalization(action.item);
    }

    return changeCartLine(action.payload);
  }

  async function updateCartAttributes(attributes) {
    const response = await fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ attributes: attributes })
    });

    const result = await response.json();

    if (!response.ok) {
      throw new Error(result.description || result.message || 'No se pudo limpiar la información adicional.');
    }

    return assignCartLineNumbers(result);
  }

  async function capturePersonalizationRemoval(line) {
    const cart = await fetchCurrentCart();
    const item = cart.items[parseInt(line, 10) - 1];
    const config = getPersonalizationConfig();

    if (!item) return null;

    if (isPersonalizationFeeItem(item, config)) {
      return {
        type: 'fee',
        parentUid: getLinkedUid(item, '_pet_name_parent_uid'),
        parentVariantId: getPropertyValue(item.properties, '_for_variant_id'),
        petName: getPersonalizationNameValue(item)
      };
    }

    if (isPersonalizedMainItem(item, config)) {
      return {
        type: 'main',
        uid: getLinkedUid(item, '_pet_name_uid'),
        variantId: String(item.variant_id || ''),
        petName: getPersonalizationNameValue(item)
      };
    }

    return null;
  }

  function getRemovalSyncAction(cart, removalContext, config) {
    if (!removalContext) return null;

    const links = linkPersonalizationItems(cart, config);

    if (removalContext.type === 'fee') {
      const candidates = links.mainItems.filter(function(item) {
        if (removalContext.parentUid) {
          return getLinkedUid(item, '_pet_name_uid') === removalContext.parentUid;
        }

        if (removalContext.parentVariantId && String(item.variant_id) !== removalContext.parentVariantId) return false;
        if (removalContext.petName && getPersonalizationNameValue(item) !== removalContext.petName) return false;
        return true;
      });

      if (candidates.length !== 1) return null;

      return {
        type: 'clean',
        item: candidates[0]
      };
    }

    if (removalContext.type === 'main') {
      const candidates = links.feeItems.filter(function(item) {
        if (removalContext.uid) {
          return getLinkedUid(item, '_pet_name_parent_uid') === removalContext.uid;
        }

        const parentVariantId = getPropertyValue(item.properties, '_for_variant_id');
        if (removalContext.variantId && parentVariantId !== removalContext.variantId) return false;
        if (removalContext.petName && getPersonalizationNameValue(item) !== removalContext.petName) return false;
        return true;
      });

      if (candidates.length !== 1) return null;

      return {
        type: 'change',
        payload: {
          id: candidates[0].key,
          quantity: 0
        }
      };
    }

    return null;
  }

  async function refreshPersonalizationCartUi() {
    const cartUrl = window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart';
    const drawerItems = document.querySelector('cart-drawer-items');

    if (drawerItems) {
      const response = await fetch(`${cartUrl}?section_id=cart-drawer`);
      const responseText = await response.text();
      const html = new DOMParser().parseFromString(responseText, 'text/html');

      ['cart-drawer-items', '.cart-drawer__footer'].forEach(function(selector) {
        const targetElement = document.querySelector(selector);
        const sourceElement = html.querySelector(selector);

        if (targetElement && sourceElement) targetElement.replaceWith(sourceElement);
      });

      return;
    }

    const cartItems = document.querySelector('cart-items');

    if (cartItems) {
      const response = await fetch(`${cartUrl}?section_id=main-cart-items`);
      const responseText = await response.text();
      const html = new DOMParser().parseFromString(responseText, 'text/html');
      const sourceElement = html.querySelector('cart-items');

      if (sourceElement) cartItems.innerHTML = sourceElement.innerHTML;
    }
  }

  async function notifyCartStateUpdated(cart) {
    updateCartCount();
    await refreshPersonalizationCartUi();

    document.dispatchEvent(new CustomEvent('cart:refresh', { detail: cart }));
    window.dispatchEvent(new CustomEvent('cart:refresh', { detail: cart }));

    try {
      if (typeof PUB_SUB_EVENTS !== 'undefined' && typeof publish === 'function') {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'pet-name-sync',
          cartData: cart
        });
      }
    } catch (error) {
      debugLog('[PetNameAttribute] Error publicando cartUpdate sincronizado:', error);
    }
  }

  async function synchronizePersonalizationCart(removalContext) {
    if (isSyncingPersonalization) {
      if (removalContext) queuedRemovalContext = removalContext;
      return null;
    }

    isSyncingPersonalization = true;

    try {
      const config = getPersonalizationConfig();
      let cart = await fetchCurrentCart();
      let hasChanges = false;
      let safetyCounter = 0;

      const removalAction = getRemovalSyncAction(cart, removalContext, config);

      if (removalAction) {
        hasChanges = true;
        cart = await executePersonalizationAction(removalAction);
      }

      while (safetyCounter < 10) {
        safetyCounter += 1;

        const links = linkPersonalizationItems(cart, config);
        const personalizedMainItems = links.mainItems;
        const feeItems = links.feeItems;
        let pendingAction = null;

        const orphanFeeItem = feeItems.find(function(feeItem) {
          return !links.feeToMain.has(feeItem.line);
        });

        if (orphanFeeItem) {
          pendingAction = {
            type: 'change',
            payload: {
              id: orphanFeeItem.key,
              quantity: 0
            }
          };
        }

        if (!pendingAction) {
          const unpairedMainItems = personalizedMainItems.filter(function(item) {
            return !links.mainToFee.has(item.line);
          });

          const orphanMainItem = personalizedMainItems.find(function(mainItem) {
            if (links.mainToFee.has(mainItem.line)) return false;
            if (feeItems.length === 0) return personalizedMainItems.length === 1;
            return unpairedMainItems.length === 1 && links.feeToMain.size === feeItems.length;
          });

          if (orphanMainItem) {
            pendingAction = {
              type: 'clean',
              item: orphanMainItem
            };
          }
        }

        if (!pendingAction) {
          const mismatchedMainItem = personalizedMainItems.find(function(mainItem) {
            const feeLine = links.mainToFee.get(mainItem.line);
            if (!feeLine) return false;

            const feeItem = feeItems.find(function(candidate) {
              return candidate.line === feeLine;
            });

            if (!feeItem) return false;
            if (getFeeQuantityMode(mainItem, feeItem, config) !== 'match_quantity') return false;

            return parseInt(feeItem.quantity, 10) !== parseInt(mainItem.quantity, 10);
          });

          if (mismatchedMainItem) {
            const mismatchedFeeItem = feeItems.find(function(candidate) {
              return candidate.line === links.mainToFee.get(mismatchedMainItem.line);
            });

            pendingAction = {
              type: 'change',
              payload: {
                id: mismatchedFeeItem.key,
                quantity: parseInt(mismatchedMainItem.quantity, 10) || 1
              }
            };
          }
        }

        if (!pendingAction) break;

        hasChanges = true;
        cart = await executePersonalizationAction(pendingAction);
      }

      const finalLinks = linkPersonalizationItems(cart, config);
      const personalizationAttributeNames = getPersonalizationCartAttributeNames(cart);
      const personalizationAttributes = {};
      let shouldClearCartAttributes = false;

      if (finalLinks.mainItems.length === 0) {
        personalizationAttributeNames.forEach(function(key) {
          const currentValue = getPropertyValue(cart && cart.attributes, key);
          if (!currentValue) return;

          personalizationAttributes[key] = '';
          shouldClearCartAttributes = true;
        });
      }

      if (shouldClearCartAttributes) {
        hasChanges = true;
        cart = await updateCartAttributes(personalizationAttributes);
      }

      if (hasChanges) {
        await notifyCartStateUpdated(cart);
      }

      return cart;
    } finally {
      isSyncingPersonalization = false;

      if (queuedRemovalContext) {
        const nextRemovalContext = queuedRemovalContext;
        queuedRemovalContext = null;

        setTimeout(function() {
          synchronizePersonalizationCart(nextRemovalContext).catch(function(error) {
            debugLog('[PetNameAttribute] Error en sync pendiente del carrito:', error);
          });
        }, 0);
      }
    }
  }

  function schedulePersonalizationSync() {
    clearTimeout(personalizationSyncTimeout);

    personalizationSyncTimeout = setTimeout(function() {
      synchronizePersonalizationCart().catch(function(error) {
        debugLog('[PetNameAttribute] Error en sync del carrito:', error);
      });
    }, 120);
  }

  function bindCartSyncSubscriptions() {
    if (cartUpdateSubscriptionBound) return;
    cartUpdateSubscriptionBound = true;

    if (typeof PUB_SUB_EVENTS !== 'undefined' && typeof subscribe === 'function') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function(event) {
        if (!event || event.source === 'pet-name-sync') return;
        if (isSyncingPersonalization) return;
        schedulePersonalizationSync();
      });
    }
  }

  function setError(message) {
    const errorElement = getErrorElement();
    const input = getInput();

    if (errorElement) {
      errorElement.textContent = message || '';
      errorElement.hidden = !message;
    }

    if (input) {
      if (message) {
        input.setAttribute('aria-invalid', 'true');
      } else {
        input.removeAttribute('aria-invalid');
      }
    }
  }

  function showFields(show) {
    const fields = getFields();

    if (fields) {
      fields.hidden = !show;
    }
  }

  function getPetName() {
    if (!isPersonalizationEnabled()) return '';

    const input = getInput();
    return cleanValue(input?.value || '');
  }

  function setPetName(value) {
    const clean = cleanValue(value);

    if (clean) {
      localStorage.setItem(STORAGE_KEY, clean);
    } else {
      localStorage.removeItem(STORAGE_KEY);
    }

    const input = getInput();

    if (input && input.value !== clean) {
      input.value = clean;
    }

    return clean;
  }

  async function syncPetNameToCart() {
    const attributeName = getAttributeName();
    const petName = getPetName();

    const attributes = {};
    attributes[attributeName] = petName;

    const response = await fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ attributes })
    });

    if (!response.ok) {
      throw new Error('No se pudo guardar el nombre de la mascota en el carrito');
    }

    const cart = await response.json();

    debugLog('[PetNameAttribute] Cart attributes actualizados:', cart.attributes);

    return cart;
  }

  function validatePersonalization() {
    if (!isPersonalizationEnabled()) {
      setError('');
      return '';
    }

    if (!getPersonalizationVariantId()) {
      const message = 'Falta configurar el producto de personalización.';
      setError(message);
      throw new Error(message);
    }

    if (!isPersonalizationProductAvailable()) {
      const message = 'La personalización no está disponible en este momento.';
      setError(message);
      throw new Error(message);
    }

    const petName = getPetName();

    if (isNameRequired() && !petName) {
      const message = 'Ingresa el nombre de tu mascota.';
      setError(message);
      getInput()?.focus();
      throw new Error(message);
    }

    setError('');
    return petName;
  }

  function buildCartItems(mainVariantId, quantity, mainProperties) {
    const parsedMainVariantId = parseInt(mainVariantId, 10);
    const parsedQuantity = Math.max(1, parseInt(quantity, 10) || 1);

    if (!parsedMainVariantId || Number.isNaN(parsedMainVariantId)) {
      throw new Error('No se pudo obtener el ID del producto principal.');
    }

    const petName = validatePersonalization();
    const attributeName = getAttributeName();
    const properties = Object.assign({}, mainProperties || {});
    const personalizationUid = isPersonalizationEnabled() ? createPersonalizationUid() : '';
    const quantityMode = getPersonalizationConfig().quantityMode;

    if (isPersonalizationEnabled()) {
      properties[attributeName] = petName;
      properties._personalizacion_nombre_mascota = 'true';
      properties._pet_name_uid = personalizationUid;
      properties._pet_name_fee_quantity_mode = quantityMode;
    }

    const items = [
      {
        id: parsedMainVariantId,
        quantity: parsedQuantity,
        properties: properties
      }
    ];

    if (isPersonalizationEnabled()) {
      items.push({
        id: getPersonalizationVariantId(),
        quantity: getFeeQuantity(parsedQuantity),
        properties: {
          _pet_name_fee: 'true',
          _pet_name_parent_uid: personalizationUid,
          _pet_name_fee_quantity_mode: quantityMode,
          _for_variant_id: String(parsedMainVariantId),
          [attributeName]: petName
        }
      });
    }

    return items;
  }

  function getFormProperties(form) {
    const properties = {};
    const formData = new FormData(form);

    formData.forEach(function(value, key) {
      const match = key.match(/^properties\[(.+)\]$/);

      if (!match) return;
      if (value === '') return;

      properties[match[1]] = value;
    });

    return properties;
  }

  function getFormVariantId(form) {
    const formData = new FormData(form);
    const variantId = formData.get('id');

    return variantId ? parseInt(variantId, 10) : null;
  }

  function getFormQuantity(form) {
    const formData = new FormData(form);
    const quantity = formData.get('quantity');

    return Math.max(1, parseInt(quantity, 10) || 1);
  }

  function getAddToCartUrl() {
    if (window.routes && window.routes.cart_add_url) {
      return window.routes.cart_add_url;
    }

    return '/cart/add.js';
  }

  function getCartElement() {
    return document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  }

  function getSectionsPayload() {
    const cartElement = getCartElement();

    if (cartElement && typeof cartElement.getSectionsToRender === 'function') {
      return {
        sections: cartElement.getSectionsToRender().map(function(section) {
          return section.id;
        }),
        sections_url: window.location.pathname
      };
    }

    return {};
  }

  async function addItemsToCart(items) {
    const body = Object.assign({ items: items }, getSectionsPayload());

    const response = await fetch(getAddToCartUrl(), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(body)
    });

    const result = await response.json();

    if (!response.ok) {
      throw new Error(result.description || result.message || 'No se pudo agregar al carrito.');
    }

    return result;
  }

  async function updateCartCount() {
    try {
      const response = await fetch('/cart.js', {
        headers: {
          'Accept': 'application/json'
        }
      });

      if (!response.ok) return;

      const cart = await response.json();
      const countElements = document.querySelectorAll('.cart-count-bubble, [data-cart-count]');

      countElements.forEach(function(element) {
        element.textContent = cart.item_count;
        element.classList.remove('hidden');
      });
    } catch (error) {
      debugLog('[PetNameAttribute] Error actualizando contador del carrito:', error);
    }
  }

    function forceCartDrawerFilledState() {
    const cartDrawer = document.querySelector('cart-drawer');

    if (!cartDrawer) return;

    cartDrawer.classList.remove('is-empty');

    const drawerInner = cartDrawer.querySelector('.drawer__inner');
    if (drawerInner) {
      drawerInner.classList.remove('is-empty');
    }

    const cartDrawerItems = cartDrawer.querySelector('cart-drawer-items');
    if (cartDrawerItems) {
      cartDrawerItems.classList.remove('is-empty');
    }

    const scrollArea = cartDrawer.querySelector('.drawer__scroll-area');
    if (scrollArea) {
      scrollArea.hidden = false;
      scrollArea.style.removeProperty('display');
      scrollArea.style.removeProperty('visibility');
      scrollArea.style.removeProperty('opacity');
    }

    const stickyFooter = cartDrawer.querySelector('.drawer__sticky-footer');
    if (stickyFooter) {
      stickyFooter.hidden = false;
      stickyFooter.style.removeProperty('display');
      stickyFooter.style.removeProperty('visibility');
      stickyFooter.style.removeProperty('opacity');
    }

    const warnings = cartDrawer.querySelector('.cart-drawer__warnings');
    if (warnings) {
      warnings.hidden = true;
    }
  }

  function openCartDrawerSafely() {
    const cartDrawer = document.querySelector('cart-drawer');

    if (!cartDrawer) return;

    forceCartDrawerFilledState();

    if (typeof cartDrawer.open === 'function') {
      cartDrawer.open();
      return;
    }

    cartDrawer.classList.add('active');
    document.body.classList.add('overflow-hidden');
  }

  function renderCart(result) {
    const cartElement = getCartElement();

    forceCartDrawerFilledState();

    if (cartElement && typeof cartElement.renderContents === 'function') {
      cartElement.renderContents(result);

      requestAnimationFrame(function() {
        forceCartDrawerFilledState();
        openCartDrawerSafely();
      });

      setTimeout(function() {
        forceCartDrawerFilledState();
        openCartDrawerSafely();
      }, 100);

      return;
    }

    updateCartCount();

    document.dispatchEvent(new CustomEvent('cart:refresh', { detail: result }));
    window.dispatchEvent(new CustomEvent('cart:refresh', { detail: result }));

    requestAnimationFrame(function() {
      forceCartDrawerFilledState();
      openCartDrawerSafely();
    });
  }

  function publishCartUpdate(result, variantId) {
    try {
      if (typeof PUB_SUB_EVENTS !== 'undefined' && typeof publish === 'function') {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'pet-name-personalization',
          productVariantId: variantId,
          cartData: result
        });
      }
    } catch (error) {
      debugLog('[PetNameAttribute] Error publicando cartUpdate:', error);
    }
  }

  function setSubmitButtonLoading(form, isLoading, errorMessage) {
    const button = form.querySelector('[type="submit"], button[name="add"], .product-form__submit');

    if (!button) return;

    if (!button.dataset.originalText) {
      button.dataset.originalText = button.textContent.trim();
    }

    button.disabled = isLoading;

    if (isLoading) {
      button.textContent = 'Adding...';
      return;
    }

    if (errorMessage) {
      button.textContent = 'Error';

      setTimeout(function() {
        button.textContent = button.dataset.originalText || 'Add to cart';
        button.disabled = false;
      }, 1800);

      return;
    }

    button.textContent = button.dataset.originalText || button.textContent;
  }

  function submitFormNormallyAfterSync(form) {
    form.dataset.petNameBypass = 'true';

    if (typeof form.requestSubmit === 'function') {
      form.requestSubmit();
    } else {
      form.submit();
    }

    setTimeout(function() {
      delete form.dataset.petNameBypass;
    }, 1000);
  }

  function interceptMainProductForms() {
    document.addEventListener('submit', async function(event) {
      const form = event.target.closest('form[action*="/cart/add"]');

      if (!form) return;

      /*
        getBlock() antes buscaba [data-pet-name-block] en TODO el documento,
        sin importar a qué producto pertenecía el formulario que realmente
        se estaba enviando. Eso secuestraba CUALQUIER submit de /cart/add en
        la página cada vez que la página actual tenía el bloque de
        personalización renderizado para OTRO producto (la PDP visitada).
        Aquí limitamos la búsqueda al mismo <product-info> del formulario
        que se está enviando, para que solo intercepte el add-to-cart del
        producto que de verdad tiene la personalización activada.
      */
      const scopedBlock = form
        .closest('product-info, .product, [data-section-type="main-product"]')
        ?.querySelector('[data-pet-name-block]');

      if (!scopedBlock) return;
      if (form.dataset.petNameBypass === 'true') return;

      event.preventDefault();
      event.stopImmediatePropagation();

      /*
        Si el submit ocurre dentro de un quick-add-modal (por ejemplo, el
        quick add de una tarjeta de recomendación en el cart-drawer),
        guardamos la referencia para, más abajo, cerrar el modal y
        refrescar el drawer con el MISMO mecanismo que usa product-form.js
        para cualquier otro producto — en vez de usar renderCart() /
        openCartDrawerSafely(), que abren el drawer por su cuenta sin
        pasar por quickAddModal.hide() y dejan el modal montado.
      */
      const quickAddModal = form.closest('quick-add-modal');

      if (!isPersonalizationEnabled()) {
        try {
          await syncPetNameToCart();
        } catch (error) {
          debugLog('[PetNameAttribute] Error limpiando/sincronizando antes de add-to-cart:', error);
        }

        submitFormNormallyAfterSync(form);
        return;
      }

      const variantId = getFormVariantId(form);
      const quantity = getFormQuantity(form);
      const properties = getFormProperties(form);

      try {
        setSubmitButtonLoading(form, true);

        const items = buildCartItems(variantId, quantity, properties);

        await syncPetNameToCart();

        const result = await addItemsToCart(items);

        if (quickAddModal) {
          const cartElement = getCartElement();

          if (quickAddModal.dataset.cartRecMobileModal === 'true') {
            quickAddModal.dataset.cartRecAdded = 'true';
          }

          // Evita que CartItems.onCartUpdate() (cart.js) dispare un fetch
          // paralelo mientras cartElement.renderContents() reconstruye el
          // drawer más abajo. Mismo guard que usa product-form.js.
          window.__cartDrawerRenderPending = true;

          const cartDrawerRenderFailsafe = setTimeout(function () {
            window.__cartDrawerRenderPending = false;
          }, 4000);

          document.body.addEventListener(
            'modalClosed',
            function () {
              setTimeout(function () {
                if (cartElement && typeof cartElement.renderContents === 'function') {
                  cartElement.renderContents(result);
                }
                clearTimeout(cartDrawerRenderFailsafe);
                window.__cartDrawerRenderPending = false;
              });
            },
            { once: true }
          );

          quickAddModal.hide(true);
        } else {
          renderCart(result);
        }

        publishCartUpdate(result, variantId);
        schedulePersonalizationSync();
        setSubmitButtonLoading(form, false);
      } catch (error) {
        debugLog('[PetNameAttribute] Error agregando producto personalizado:', error);

        setError(error.message || 'No se pudo agregar la personalización.');
        setSubmitButtonLoading(form, false, error.message);
      }
    }, true);
  }

  function interceptCheckoutButtons() {
    document.addEventListener('click', async function(event) {
      const checkoutButton = event.target.closest(
        'button[name="checkout"], input[name="checkout"], a[href="/checkout"], a[href*="/checkout"]'
      );

      if (!checkoutButton) return;
      if (!getBlock()) return;
      if (checkoutButton.dataset.petNameSynced === 'true') return;

      event.preventDefault();
      event.stopImmediatePropagation();

      try {
        await syncPetNameToCart();

        checkoutButton.dataset.petNameSynced = 'true';
        checkoutButton.click();

        setTimeout(function() {
          delete checkoutButton.dataset.petNameSynced;
        }, 1000);
      } catch (error) {
        debugLog('[PetNameAttribute] Error sincronizando antes de checkout:', error);

        delete checkoutButton.dataset.petNameSynced;
        checkoutButton.click();
      }
    }, true);
  }

  /*
    quick-add.js inyecta el <product-info> (incluyendo el bloque de
    personalización, si el producto lo tiene) dentro del modal vía
    innerHTML, sin disparar 'DOMContentLoaded' ni 'shopify:section:load'.
    Sin esto, el toggle y el input del bloque recién insertado quedarían
    sin sus listeners y no responderían dentro del quick-add.
  */
  function observeDynamicPetNameBlocks() {
    if (window.__petNameBlockObserverReady) return;
    window.__petNameBlockObserverReady = true;

    const observer = new MutationObserver(function (mutations) {
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (!(node instanceof HTMLElement)) continue;

          const hasBlock =
            node.matches?.('[data-pet-name-block]') || node.querySelector?.('[data-pet-name-block]');

          if (hasBlock) {
            initPetNameBlock();
            return;
          }
        }
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  function initPetNameBlock() {
    const block = getBlock();
    const input = getInput();
    const toggle = getToggle();

    if (!block || !input || input.dataset.petNameInitialized === 'true') return;

    input.dataset.petNameInitialized = 'true';

    const savedValue = localStorage.getItem(STORAGE_KEY) || '';
    const wasEnabled = localStorage.getItem(ENABLED_STORAGE_KEY) === 'true';
    const shouldEnable = Boolean(toggle && !toggle.disabled && (wasEnabled || savedValue));

    if (toggle) {
      toggle.checked = shouldEnable;
    }

    showFields(shouldEnable || !toggle);

    if (savedValue && shouldEnable) {
      input.value = savedValue;
      syncPetNameToCart().catch(function(error) {
        debugLog('[PetNameAttribute] Error sincronizando nombre inicial:', error);
      });
    }

    let timeout;

    if (toggle) {
      toggle.addEventListener('change', function(event) {
        const enabled = Boolean(event.target.checked);

        localStorage.setItem(ENABLED_STORAGE_KEY, enabled ? 'true' : 'false');
        showFields(enabled);
        setError('');

        if (!enabled) {
          setPetName('');
        } else {
          input.focus();
        }

        syncPetNameToCart().catch(function(error) {
          debugLog('[PetNameAttribute] Error sincronizando toggle:', error);
        });
      });
    }

    input.addEventListener('input', function(event) {
      setPetName(event.target.value);
      setError('');

      clearTimeout(timeout);

      timeout = setTimeout(function() {
        syncPetNameToCart().catch(function(error) {
          debugLog('[PetNameAttribute] Error sincronizando input:', error);
        });
      }, 400);
    });

    input.addEventListener('change', function(event) {
      setPetName(event.target.value);
      syncPetNameToCart().catch(function(error) {
        debugLog('[PetNameAttribute] Error sincronizando change:', error);
      });
    });

    input.addEventListener('blur', function(event) {
      setPetName(event.target.value);
      syncPetNameToCart().catch(function(error) {
        debugLog('[PetNameAttribute] Error sincronizando blur:', error);
      });
    });
  }

  window.PetNameAttribute = {
    get: getPetName,
    set: setPetName,
    sync: syncPetNameToCart,
    syncCart: synchronizePersonalizationCart,
    scheduleCartSync: schedulePersonalizationSync,
    captureRemoval: capturePersonalizationRemoval,
    enabled: isPersonalizationEnabled,
    buildCartItems: buildCartItems,
    validate: validatePersonalization
  };

  document.addEventListener('DOMContentLoaded', function() {
    initPetNameBlock();
    observeDynamicPetNameBlocks();
    interceptMainProductForms();
    interceptCheckoutButtons();
    bindCartSyncSubscriptions();
    schedulePersonalizationSync();
  });

  document.addEventListener('shopify:section:load', function() {
    initPetNameBlock();
  });

  document.addEventListener('cart:refresh', function() {
    if (isSyncingPersonalization) return;
    schedulePersonalizationSync();
  });

  window.addEventListener('cart:refresh', function() {
    if (isSyncingPersonalization) return;
    schedulePersonalizationSync();
  });
})();
